var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgEmurgo = function SvgEmurgo(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 87 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8_4537)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M75.6118 12.9862C75.2095 12.9862 74.8303 12.8827 74.497 12.6988C74.1637 12.5035 73.8993 12.2276 73.7039 11.8828C73.5085 11.5265 73.4166 11.1243 73.4166 10.6645C73.4166 10.2163 73.52 9.80256 73.7039 9.44627C73.8993 9.08998 74.1522 8.82564 74.497 8.63026C74.8303 8.43487 75.1981 8.34293 75.6118 8.34293C76.0141 8.34293 76.3933 8.44636 76.7266 8.63026C77.0599 8.82564 77.3243 9.10148 77.5197 9.44627C77.7151 9.80256 77.807 10.2048 77.807 10.6645C77.807 11.1243 77.7036 11.5265 77.5197 11.8828C77.3358 12.2391 77.0599 12.5035 76.7266 12.6988C76.3933 12.8942 76.0141 12.9862 75.6118 12.9862ZM75.6118 14.894C76.4738 14.894 77.2438 14.7101 77.9334 14.3539C78.6115 13.9976 79.1517 13.4919 79.5425 12.8368C79.9332 12.1931 80.1286 11.4691 80.1286 10.6645C80.1286 9.86002 79.9332 9.13595 79.5425 8.49234C79.1517 7.84872 78.6115 7.34302 77.9334 6.97524C77.2553 6.61895 76.4738 6.43506 75.6118 6.43506C74.7498 6.43506 73.9798 6.61895 73.2902 6.97524C72.6006 7.33153 72.0719 7.83722 71.6811 8.49234C71.2904 9.13595 71.095 9.86002 71.095 10.6645C71.095 11.4691 71.2904 12.1931 71.6811 12.8368C72.0719 13.4804 72.6121 13.9861 73.2902 14.3539C73.9798 14.7101 74.7498 14.894 75.6118 14.894ZM67.3597 12.7218C66.9804 12.8942 66.5667 12.9862 66.1184 12.9862C65.6702 12.9862 65.2794 12.8827 64.9232 12.6873C64.5784 12.492 64.3025 12.2161 64.1071 11.8713C63.9118 11.515 63.8198 11.1243 63.8198 10.6645C63.8198 9.96346 64.0382 9.4003 64.4519 8.97505C64.8772 8.5498 65.4403 8.34293 66.1299 8.34293C66.9 8.34293 67.5551 8.64175 68.1068 9.25089L69.5779 7.92917C69.1756 7.44646 68.6699 7.09017 68.0608 6.82583C67.4516 6.57298 66.7736 6.44655 66.015 6.44655C65.153 6.44655 64.3715 6.61895 63.6819 6.98673C62.9923 7.34302 62.4521 7.84872 62.0728 8.49234C61.6936 9.13595 61.4867 9.87152 61.4867 10.676C61.4867 11.4921 61.6821 12.2161 62.0728 12.8597C62.4521 13.5034 62.9923 14.0091 63.6819 14.3653C64.36 14.7216 65.13 14.9055 65.9805 14.9055C66.5897 14.9055 67.1873 14.8136 67.7964 14.6412C68.4056 14.4688 68.9343 14.2159 69.4055 13.8711V10.5036H67.3712V12.7218H67.3597ZM57.602 9.60717C57.602 9.98645 57.4756 10.2853 57.2457 10.4807C57.0044 10.6875 56.6481 10.791 56.1768 10.791H54.9011V8.41189H56.1768C56.6481 8.41189 57.0044 8.51532 57.2457 8.7222C57.4871 8.92908 57.602 9.2279 57.602 9.60717ZM57.625 14.7331H60.0845L58.3376 12.1816C58.8548 11.9403 59.2455 11.5955 59.5214 11.1473C59.7972 10.7105 59.9351 10.1933 59.9351 9.60717C59.9351 8.99804 59.7857 8.45786 59.4984 8.00962C59.211 7.56139 58.7858 7.2166 58.2456 6.96375C57.7054 6.72239 57.0618 6.59596 56.3263 6.59596H52.591V14.7216H54.8896V12.5609H56.1424L57.625 14.7331ZM46.5226 14.894C47.7294 14.894 48.6718 14.5607 49.3384 13.9056C50.005 13.2505 50.3498 12.3196 50.3498 11.1013V6.60746H48.0857V11.0438C48.0857 12.3425 47.5685 12.9977 46.5456 12.9977C45.5112 12.9977 45.0055 12.3425 45.0055 11.0438V6.60746H42.7069V11.1128C42.7069 12.3196 43.0401 13.2505 43.7182 13.9171C44.3734 14.5607 45.3273 14.894 46.5226 14.894ZM40.4542 14.7331V6.60746H38.5578L35.7765 11.2967L32.9147 6.60746H31.0298V14.7331H33.156V10.5381L35.2363 13.9286H36.2477L38.3394 10.4232V14.7331H40.4542ZM24.7545 12.9517V11.4576H28.3634V9.7336H24.7545V8.36591H28.8576V6.58447H22.4904V14.7101H29.0185V12.9402H24.7545V12.9517Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.882 5.86043C14.8976 5.86043 15.7209 5.03713 15.7209 4.02152C15.7209 3.00592 14.8976 2.18262 13.882 2.18262C12.8664 2.18262 12.0431 3.00592 12.0431 4.02152C12.0431 5.03713 12.8664 5.86043 13.882 5.86043Z",
    fill: "url(#paint0_linear_8_4537)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8588 9.79107C17.7855 9.79107 18.5368 9.0398 18.5368 8.11306C18.5368 7.18633 17.7855 6.43506 16.8588 6.43506C15.9321 6.43506 15.1808 7.18633 15.1808 8.11306C15.1808 9.0398 15.9321 9.79107 16.8588 9.79107Z",
    fill: "url(#paint1_linear_8_4537)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8589 14.8941C17.7031 14.8941 18.3875 14.2097 18.3875 13.3655C18.3875 12.5213 17.7031 11.8369 16.8589 11.8369C16.0147 11.8369 15.3303 12.5213 15.3303 13.3655C15.3303 14.2097 16.0147 14.8941 16.8589 14.8941Z",
    fill: "url(#paint2_linear_8_4537)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.882 18.8248C14.6437 18.8248 15.2612 18.2073 15.2612 17.4456C15.2612 16.6839 14.6437 16.0664 13.882 16.0664C13.1203 16.0664 12.5028 16.6839 12.5028 17.4456C12.5028 18.2073 13.1203 18.8248 13.882 18.8248Z",
    fill: "url(#paint3_linear_8_4537)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.9629 20.273C9.63574 20.273 10.1812 19.7275 10.1812 19.0547C10.1812 18.3819 9.63574 17.8364 8.9629 17.8364C8.29007 17.8364 7.74463 18.3819 7.74463 19.0547C7.74463 19.7275 8.29007 20.273 8.9629 20.273Z",
    fill: "url(#paint4_linear_8_4537)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.06703 18.5142C4.65735 18.5142 5.1359 18.0356 5.1359 17.4453C5.1359 16.855 4.65735 16.3765 4.06703 16.3765C3.47672 16.3765 2.99817 16.855 2.99817 17.4453C2.99817 18.0356 3.47672 18.5142 4.06703 18.5142Z",
    fill: "url(#paint5_linear_8_4537)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.07874 14.2734C1.58019 14.2734 1.9867 13.8669 1.9867 13.3655C1.9867 12.864 1.58019 12.4575 1.07874 12.4575C0.577284 12.4575 0.170776 12.864 0.170776 13.3655C0.170776 13.8669 0.577284 14.2734 1.07874 14.2734Z",
    fill: "url(#paint6_linear_8_4537)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.07874 8.87159C1.49768 8.87159 1.83729 8.53198 1.83729 8.11304C1.83729 7.69411 1.49768 7.35449 1.07874 7.35449C0.659805 7.35449 0.32019 7.69411 0.32019 8.11304C0.32019 8.53198 0.659805 8.87159 1.07874 8.87159Z",
    fill: "url(#paint7_linear_8_4537)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.06702 4.63087C4.40344 4.63087 4.67616 4.35815 4.67616 4.02174C4.67616 3.68532 4.40344 3.4126 4.06702 3.4126C3.73061 3.4126 3.45789 3.68532 3.45789 4.02174C3.45789 4.35815 3.73061 4.63087 4.06702 4.63087Z",
    fill: "url(#paint8_linear_8_4537)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.96268 4.41218C10.0608 4.41218 10.951 3.52198 10.951 2.42387C10.951 1.32575 10.0608 0.435547 8.96268 0.435547C7.86457 0.435547 6.97437 1.32575 6.97437 2.42387C6.97437 3.52198 7.86457 4.41218 8.96268 4.41218Z",
    fill: "url(#paint9_linear_8_4537)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5375 8.50376C12.0961 8.50376 12.5489 8.05094 12.5489 7.49236C12.5489 6.93378 12.0961 6.48096 11.5375 6.48096C10.9789 6.48096 10.5261 6.93378 10.5261 7.49236C10.5261 8.05094 10.9789 8.50376 11.5375 8.50376Z",
    fill: "url(#paint10_linear_8_4537)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1809 10.6876C13.6951 10.6876 14.1119 10.2708 14.1119 9.75663C14.1119 9.24248 13.6951 8.82568 13.1809 8.82568C12.6668 8.82568 12.25 9.24248 12.25 9.75663C12.25 10.2708 12.6668 10.6876 13.1809 10.6876Z",
    fill: "url(#paint11_linear_8_4537)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1809 13.5149C13.6443 13.5149 14.0199 13.1393 14.0199 12.6759C14.0199 12.2125 13.6443 11.8369 13.1809 11.8369C12.7176 11.8369 12.3419 12.2125 12.3419 12.6759C12.3419 13.1393 12.7176 13.5149 13.1809 13.5149Z",
    fill: "url(#paint12_linear_8_4537)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5376 15.687C11.9565 15.687 12.2962 15.3474 12.2962 14.9285C12.2962 14.5095 11.9565 14.1699 11.5376 14.1699C11.1187 14.1699 10.7791 14.5095 10.7791 14.9285C10.7791 15.3474 11.1187 15.687 11.5376 15.687Z",
    fill: "url(#paint13_linear_8_4537)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.81359 16.4914C9.1881 16.4914 9.49169 16.1879 9.49169 15.8134C9.49169 15.4388 9.1881 15.1353 8.81359 15.1353C8.43909 15.1353 8.1355 15.4388 8.1355 15.8134C8.1355 16.1879 8.43909 16.4914 8.81359 16.4914Z",
    fill: "url(#paint14_linear_8_4537)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.08981 15.5146C6.41354 15.5146 6.67597 15.2522 6.67597 14.9284C6.67597 14.6047 6.41354 14.3423 6.08981 14.3423C5.76609 14.3423 5.50366 14.6047 5.50366 14.9284C5.50366 15.2522 5.76609 15.5146 6.08981 15.5146Z",
    fill: "url(#paint15_linear_8_4537)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.43465 13.1813C4.71395 13.1813 4.94035 12.9549 4.94035 12.6756C4.94035 12.3963 4.71395 12.1699 4.43465 12.1699C4.15536 12.1699 3.92896 12.3963 3.92896 12.6756C3.92896 12.9549 4.15536 13.1813 4.43465 13.1813Z",
    fill: "url(#paint16_linear_8_4537)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.43489 10.1815C4.66975 10.1815 4.86014 9.99116 4.86014 9.7563C4.86014 9.52144 4.66975 9.33105 4.43489 9.33105C4.20003 9.33105 4.00964 9.52144 4.00964 9.7563C4.00964 9.99116 4.20003 10.1815 4.43489 10.1815Z",
    fill: "url(#paint17_linear_8_4537)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.08953 7.82579C6.27361 7.82579 6.42283 7.67656 6.42283 7.49248C6.42283 7.30841 6.27361 7.15918 6.08953 7.15918C5.90545 7.15918 5.75623 7.30841 5.75623 7.49248C5.75623 7.67656 5.90545 7.82579 6.08953 7.82579Z",
    fill: "url(#paint18_linear_8_4537)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.81343 7.7106C9.42279 7.7106 9.91677 7.21661 9.91677 6.60725C9.91677 5.99789 9.42279 5.50391 8.81343 5.50391C8.20407 5.50391 7.71008 5.99789 7.71008 6.60725C7.71008 7.21661 8.20407 7.7106 8.81343 7.7106Z",
    fill: "url(#paint19_linear_8_4537)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.98561 10.0322C10.2395 10.0322 10.4453 9.82642 10.4453 9.57252C10.4453 9.31862 10.2395 9.11279 9.98561 9.11279C9.73171 9.11279 9.52588 9.31862 9.52588 9.57252C9.52588 9.82642 9.73171 10.0322 9.98561 10.0322Z",
    fill: "url(#paint20_linear_8_4537)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.7326 11.0209C10.9675 11.0209 11.1579 10.8305 11.1579 10.5957C11.1579 10.3608 10.9675 10.1704 10.7326 10.1704C10.4978 10.1704 10.3074 10.3608 10.3074 10.5957C10.3074 10.8305 10.4978 11.0209 10.7326 11.0209Z",
    fill: "url(#paint21_linear_8_4537)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.7324 12.2849C10.9419 12.2849 11.1117 12.1151 11.1117 11.9056C11.1117 11.6962 10.9419 11.5264 10.7324 11.5264C10.523 11.5264 10.3531 11.6962 10.3531 11.9056C10.3531 12.1151 10.523 12.2849 10.7324 12.2849Z",
    fill: "url(#paint22_linear_8_4537)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.98542 13.2736C10.1758 13.2736 10.3302 13.1192 10.3302 12.9288C10.3302 12.7384 10.1758 12.584 9.98542 12.584C9.795 12.584 9.64062 12.7384 9.64062 12.9288C9.64062 13.1192 9.795 13.2736 9.98542 13.2736Z",
    fill: "url(#paint23_linear_8_4537)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.76735 13.6411C8.93873 13.6411 9.07766 13.5022 9.07766 13.3308C9.07766 13.1594 8.93873 13.0205 8.76735 13.0205C8.59596 13.0205 8.45703 13.1594 8.45703 13.3308C8.45703 13.5022 8.59596 13.6411 8.76735 13.6411Z",
    fill: "url(#paint24_linear_8_4537)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.53741 13.1927C7.68341 13.1927 7.80176 13.0744 7.80176 12.9284C7.80176 12.7824 7.68341 12.6641 7.53741 12.6641C7.39142 12.6641 7.27307 12.7824 7.27307 12.9284C7.27307 13.0744 7.39142 13.1927 7.53741 13.1927Z",
    fill: "url(#paint25_linear_8_4537)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.79029 12.1355C6.91724 12.1355 7.02015 12.0326 7.02015 11.9056C7.02015 11.7787 6.91724 11.6758 6.79029 11.6758C6.66334 11.6758 6.56042 11.7787 6.56042 11.9056C6.56042 12.0326 6.66334 12.1355 6.79029 12.1355Z",
    fill: "url(#paint26_linear_8_4537)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.79073 10.7914C6.89885 10.7914 6.9865 10.7038 6.9865 10.5957C6.9865 10.4876 6.89885 10.3999 6.79073 10.3999C6.68262 10.3999 6.59497 10.4876 6.59497 10.5957C6.59497 10.7038 6.68262 10.7914 6.79073 10.7914Z",
    fill: "url(#paint27_linear_8_4537)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.53788 9.72274C7.62056 9.72274 7.68759 9.65572 7.68759 9.57304C7.68759 9.49036 7.62056 9.42334 7.53788 9.42334C7.45521 9.42334 7.38818 9.49036 7.38818 9.57304C7.38818 9.65572 7.45521 9.72274 7.53788 9.72274Z",
    fill: "url(#paint28_linear_8_4537)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.76728 9.67591C9.04022 9.67591 9.26148 9.45465 9.26148 9.18171C9.26148 8.90876 9.04022 8.6875 8.76728 8.6875C8.49434 8.6875 8.27307 8.90876 8.27307 9.18171C8.27307 9.45465 8.49434 9.67591 8.76728 9.67591Z",
    fill: "url(#paint29_linear_8_4537)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8_4537",
    x1: 1.18749,
    y1: 16.7205,
    x2: 15.411,
    y2: 2.49698,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF1055"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_8_4537",
    x1: 4.68871,
    y1: 20.2828,
    x2: 18.9122,
    y2: 6.05927,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF1055"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_8_4537",
    x1: 7.29173,
    y1: 22.9315,
    x2: 21.5152,
    y2: 8.70794,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF1055"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_8_4537",
    x1: 7.83943,
    y1: 23.4892,
    x2: 22.0629,
    y2: 9.26563,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF1055"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_8_4537",
    x1: 6.19906,
    y1: 21.8205,
    x2: 20.4225,
    y2: 7.59695,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF1055"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_8_4537",
    x1: 2.97206,
    y1: 18.5367,
    x2: 17.1955,
    y2: 4.31317,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF1055"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_8_4537",
    x1: -0.529166,
    y1: 14.9746,
    x2: 13.6943,
    y2: 0.751068,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF1055"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_8_4537",
    x1: -3.13208,
    y1: 12.3259,
    x2: 11.0914,
    y2: -1.8976,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF1055"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_8_4537",
    x1: -3.67989,
    y1: 11.7685,
    x2: 10.5436,
    y2: -2.45502,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF1055"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_8_4537",
    x1: -2.04381,
    y1: 13.4331,
    x2: 12.1797,
    y2: -0.790462,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF1055"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_8_4537",
    x1: 1.74312,
    y1: 17.2859,
    x2: 15.9666,
    y2: 3.06231,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF1055"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_8_4537",
    x1: 3.68005,
    y1: 19.2569,
    x2: 17.9035,
    y2: 5.03334,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF1055"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_8_4537",
    x1: 5.12611,
    y1: 20.7283,
    x2: 19.3496,
    y2: 6.50477,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF1055"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_8_4537",
    x1: 5.42687,
    y1: 21.0342,
    x2: 19.6503,
    y2: 6.81065,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF1055"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_8_4537",
    x1: 4.52096,
    y1: 20.1126,
    x2: 18.7444,
    y2: 5.88903,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF1055"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_8_4537",
    x1: 2.72855,
    y1: 18.289,
    x2: 16.952,
    y2: 4.06542,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF1055"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_8_4537",
    x1: 0.791375,
    y1: 16.3179,
    x2: 15.0149,
    y2: 2.09434,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF1055"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_8_4537",
    x1: -0.654482,
    y1: 14.8464,
    x2: 13.569,
    y2: 0.622859,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF1055"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_8_4537",
    x1: -0.955412,
    y1: 14.5408,
    x2: 13.2681,
    y2: 0.317234,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF1055"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_8_4537",
    x1: -0.0457692,
    y1: 15.4659,
    x2: 14.1777,
    y2: 1.24231,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF1055"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_8_4537",
    x1: 2.00908,
    y1: 17.5569,
    x2: 16.2325,
    y2: 3.33333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF1055"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_8_4537",
    x1: 2.88432,
    y1: 18.4477,
    x2: 17.1078,
    y2: 4.22413,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF1055"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_8_4537",
    x1: 3.53487,
    y1: 19.1096,
    x2: 17.7584,
    y2: 4.88609,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF1055"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_8_4537",
    x1: 3.67188,
    y1: 19.2493,
    x2: 17.8954,
    y2: 5.02574,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF1055"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_8_4537",
    x1: 3.26487,
    y1: 18.8348,
    x2: 17.4884,
    y2: 4.61123,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF1055"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_8_4537",
    x1: 2.4579,
    y1: 18.0137,
    x2: 16.6813,
    y2: 3.79016,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF1055"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_8_4537",
    x1: 1.58254,
    y1: 17.1233,
    x2: 15.806,
    y2: 2.89974,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF1055"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_8_4537",
    x1: 0.920861,
    y1: 16.4728,
    x2: 15.1719,
    y2: 2.22158,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF1055"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_8_4537",
    x1: 0.782273,
    y1: 16.3354,
    x2: 15.0334,
    y2: 2.08418,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF1055"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_8_4537",
    x1: 1.20604,
    y1: 16.7398,
    x2: 15.4295,
    y2: 2.51626,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF1055"
  })), /*#__PURE__*/React.createElement("clip-path", {
    id: "clip0_8_4537"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 85.8428,
    height: 21.3222,
    fill: "white",
    transform: "translate(0.222656 0.338867)"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgEmurgo);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "emurgo.ee0f896.svg";